export var startSubscribeMixin = {
  methods: {
    async startSubscribe() {
      this.loading = true;
      this.showError = false;

      if (
        this.SubscribeFlowDetails.checkoutHeaderEnrichmentInfo
          .pinCodeVerification === false
      ) {
        await this.confrimHeaderEnrichement();
      } else {
        this.moveToPincodeStep();
      }
    },
    async confrimHeaderEnrichement() {
      let response = await this.$http.post('/HeaderEnrichment/Confirm', {
        //Empty object
      });
      //1.. success case.
      if (
        response.data &&
        response.data.enrichementRefNumber &&
        response.data.error == null
      ) {
        await this.confirmSubscriptionResult();
      }
      //2.. failure case.
      else if (response.data.error) {
        switch (response.data.error) {
          case 'Invalid catalog':
          case 'Invalid product':
          case 'Invalid subscription plan':
            this.moveToFailurePage(
              this.$translate('GENERALERRORMESSAGE'), //optional
              '51'
            );
            break;
          default:
            this.moveToFailurePage(
              this.$translate('GENERALERRORMESSAGE'), //optional
              '51'
            );
            break;
        }
      }
    },
    async confirmSubscriptionResult() {
      let response = await this.$http.post('/sub/SubscribeContract', {
        simulate: process.env.NODE_ENV === 'development' ? false : false,
        sessionToken: this.SubscribeFlowDetails.sessionToken,
      });
      /*========= response object Template ========== */
      // let response = {
      //   data: {
      //     charge: true,
      //     errorMessage: null,
      //     msisdn: '201021320396',
      //     nextPaymentDate: '2022-03-02 13:20:15Z',
      //     operationStatusCode: '0',
      //     paymentTransactionStatusCode: '6',
      //     responseCode: 51,
      //     statusCode: 0,
      //     subscriptionContractId: 412783052,
      //     subscriptionContractStatus: '1',
      //     transactionId: '21149053178',
      //     verificationInstruction: null,
      //     verificationMethod: null,
      //   },
      // };
      /*============================================= */

      this.loading = false;
      if (response.data.errorMessage) {
        if (response.data.responseCode === 105) {
          this.moveToFailurePage(
            this.$translate(`RESPONSECODE_${response.data.responseCode}`), //optional
            response.data.responseCode
          );
        } else {
          this.moveToFailurePage(
            this.$translate('GENERALERRORMESSAGE'), //optional
            response.data.operationStatusCode
          );
        }
      } else if (
        response.data.transactionId &&
        response.data.paymentTransactionStatusCode != 0
      ) {
        switch (Number(response.data.paymentTransactionStatusCode)) {
          case 4:
          case 11:
          case 14:
          case 16:
            this.showErrorMessage(
              this.$translate(
                `RESPONSECODE_${response.data.paymentTransactionStatusCode}`
              )
            );
            break;
          case 6:
            this.moveToFailurePage(
              this.$translate('GENERALERRORMESSAGE'), //optional
              response.data.operationStatusCode
            );
            break;
          default:
            this.showErrorMessage(this.$translate('GENERALERRORMESSAGE'));
            break;
        }
      } else {
        this.moveToSuccessPage(response.data.subscriptionContractId);
      }
    },
    moveToFailurePage(msg, operationStatusCode, reloadInFailure = false) {
      this.setSubscribeFlowDetails({
        step: 4,
        component: 'HEFailure',
        failureMessage: msg,
        operationStatusCode,
        reloadInFailure,
      });
    },
    moveToPincodeStep() {
      //move to "PinCode" step.
      this.setSubscribeFlowDetails({
        step: 2,
        component: 'HEPincode',
      });
    },
    showErrorMessage(msg) {
      this.error = msg;
      this.showError = true;
    },
    moveToSuccessPage(id) {
      this.setSubscribeFlowDetails({
        step: 3,
        component: 'HESuccess',
        paymentId: id,
      });
    },
  },
};
